module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TabSelect', {
    attrs: {
      "options": _vm.options,
      "value": _vm.value,
      "name": _vm.name
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ba69028!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/tab-select.vue
// module id = 2042
// module chunks = 2